import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialog: {
    // zIndex: `1000 !important`,

    '& .MuiPaper-root': {
      width: '90%',
      maxWidth: 600,
    },
  },
  container: {
    position: 'relative',
    padding: theme.spacing(4),
  },

  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
  },
  closeIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
  },
  subtitle: {
    textAlign: 'center',
    width: '100%',
    fontWeight: 'bold',
    marginTop: 10,
  },

  loadingContainer: {
    padding: `200px 0`,
  },
  loadingText: {
    textAlign: 'center',
    fontSize: 18,
    lineHeight: 1.5,
    fontWeight: 'bold',
    margin: `${theme.spacing(2)}px 0`,
  },
  cancelButton: {
    backgroundColor: theme.colors.danger,
    color: theme.colors.white,
  },

  inputContainer: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  textFieldContainer: {
    position: 'relative',
  },
  textFieldButtons: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    marginTop: theme.spacing(4),
  },
  button: {
    marginBottom: theme.spacing(2),
    width: 200,
  },
  closeBtn: {
    backgroundColor: theme.colors.darkGrey,
    color: theme.colors.white,
    marginTop: theme.spacing(3),
    '&:hover': {
      backgroundColor: theme.palette.action.disabled,
    },
  },
  iconLarge: {
    fontSize: '6rem',
  },
}));

export default useStyles;
